<template>
    <div>
        <calculator-base-header-sec></calculator-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">

                <iframe :style="iframeStyle" @load="load" ref="ifr" id="ifr" class="static-iframe" width="100%"
                    :src="baseApiUrl + 'prins/viewdoc?uuid=a4d0d4fc-c3f6-4fad-b29a-d444095f0afa&staticpageid=28&doctype=fpstaticpage'"
                    frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

import CalculatorBaseHeaderSec from '@/base_pages/calc/CalculatorBaseHeaderSec.vue';


export default {
    name: "CalculatorHelp",
    components: {
        CalculatorBaseHeaderSec,
    },


    data() {
        return {
            iframeStyle: {
                height: '800px',
            },
            loaded: false,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,

            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {},
    methods: {
        load: function () {
            this.loaded = true;
            // setTimeout(iResize, 50);
            // console.log(this.$refs['ifr']);
            //
            // this.iframeStyle.height = this.$refs['ifr'].contentWindow.document.body.offsetHeight + 'px';
        }
    },
    mounted() {

    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style scoped></style>
